import type { MessageDescriptor } from '@lingui/core';
import { msg, plural } from '@lingui/core/macro';

// Shared by the phone and email verification countdowns so both resolve the same
// translation unit: keep the wording and the resendCountdown argument name.
export const resendCountdownLabel = (resendCountdown: number): MessageDescriptor =>
  msg`${plural(resendCountdown, {
    one: 'Send new code in # second',
    other: 'Send new code in # seconds',
  })}`;
